var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsaPsgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.6,103.7l-26.8,35.8h-3.1l-26.2-35.9v59.9h-15.5v-82.4h17.9l25.8,35.4,25.8-35.4h17.8v82.4h-15.5v-59.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.6,100.9c-2.8-4.7-10.6-9.2-19.5-9.2s-17.1,4.8-17.1,10.9,8.5,9.2,18.4,10.4c17.2,2.1,33.2,6.6,33.2,26.2s-16.2,26.2-34.6,26.2-29.8-5.2-35.9-20.2l12.9-6.7c3.6,9.1,13.2,13.1,23.2,13.1s19-3.4,19-12.4-8.1-10.9-19.1-12.1c-16.8-2-32.4-6.5-32.4-25s16.7-23.9,31.9-24c12.8,0,26.1,3.6,32.4,16.4l-12.4,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494.1,147.8h-43.1l-7.1,15.5h-16.8l37-82.4h16.9l37,82.4h-16.9l-6.9-15.5ZM472.5,98.3l-15.3,35.1h30.6l-15.3-35.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M586.4,139.1h-23.3v24.2h-15.5v-82.4c12.9,0,25.9-.1,38.8-.1,40.3,0,40.4,58.3,0,58.3ZM563.1,124.9h23.3c19.9,0,19.8-29.2,0-29.2h-23.3v29.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M677.9,100.9c-2.8-4.7-10.6-9.2-19.5-9.2s-17.1,4.8-17.1,10.9,8.5,9.2,18.4,10.4c17.2,2.1,33.2,6.6,33.2,26.2s-16.2,26.2-34.6,26.2-29.8-5.2-35.9-20.2l12.9-6.7c3.6,9.1,13.2,13.1,23.2,13.1s19-3.4,19-12.4-8.1-10.9-19.1-12.1c-16.8-2-32.4-6.5-32.4-25s16.7-23.9,31.9-24c12.8,0,26.1,3.6,32.4,16.4l-12.4,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M766.1,101.1c-5.5-5.3-13.8-8.2-21-8.2-17.7,0-28.4,13.4-28.4,30.4s7.9,27.5,28.4,27.5,12.1-1.4,18.6-6.6v-14.6h-21.1v-13.9h35.3v34.7c-8.1,9.3-18.4,14.8-32.8,14.8-31,0-43.6-20.4-43.6-42s14.5-44.6,43.6-44.6,22.1,4.2,30.6,12.6l-9.7,9.9Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.5,224.8c-.1-8.1-6.6-14.5-14.7-14.5s-14.6,6.4-14.7,14.5h29.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "60.7 134.6 60.7 198.8 100.2 211.3 100.2 211.3 52.6 204.2 52.6 126.8 60.7 134.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "82.2 148.1 82.2 188.9 99.3 202.4 99.3 202.4 74.1 194.3 74.1 140.3 82.2 148.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.1,61.4c-14.9-12.1-30.3-24.6-42-41.1l-3.6-5.2-3.6,5.2c-11.6,16.4-26.4,28.7-40.7,40.7-28.8,24-55.8,46.7-55.8,97.3v62.9h75.8l-66.8-5.8v-61.6c1.6-43.2,25-63,52.4-85.9,13.3-11.1,27.1-22.6,38.7-37.5,11.8,15.1,26.1,26.7,40.1,37.9,26.8,21.7,52.3,42.4,54.2,84.7v7h-.1v55.3l-66.3,5.8h75.3v-62.9c0-50.3-29.2-74-57.5-96.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "150.6 190.8 150.6 153.7 138.6 144.6 138.6 144.6 155.1 150 155.1 186.3 150.6 190.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "107.4 190.8 107.4 153.7 119.4 144.6 119.4 144.6 102.9 150 102.9 186.3 107.4 190.8"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 129,
    cy: 127.4,
    r: 15.4
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "197.3 134.6 197.3 198.8 156.9 211.3 156.9 211.3 205.4 204.2 205.4 126.8 197.3 134.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "175.8 148.1 175.8 188.9 158.7 202.4 158.7 202.4 183.9 194.3 183.9 140.3 175.8 148.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "61.8 124 72 116.3 72 116.3 58 120.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "96.5 122.4 88.3 116.3 88.3 116.3 99.5 120"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.3,101.6c0-7.2-5.9-13.1-13.1-13.1s-13.1,5.9-13.1,13.1,5.9,13.1,13.1,13.1,13.1-5.9,13.1-13.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "130.9 124 120.7 116.3 120.7 116.3 134.7 120.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "96.5 122.4 104.3 116.3 104.3 116.3 93.3 119.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.6,101.6c0-7.2-5.9-13.1-13.1-13.1s-13.1,5.9-13.1,13.1,5.9,13.1,13.1,13.1,13.1-5.9,13.1-13.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "161.2 122.4 153.1 116.3 153.1 116.3 164.3 120"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "126.5 124 136.7 116.3 136.7 116.3 122.7 120.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158,101.6c0-7.2-5.9-13.1-13.1-13.1s-13.1,5.9-13.1,13.1,5.9,13.1,13.1,13.1,13.1-5.9,13.1-13.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "195.6 124 185.4 116.3 185.4 116.3 199.4 120.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "161.2 122.4 169.1 116.3 169.1 116.3 158 119.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.4,101.6c0-7.2-5.9-13.1-13.1-13.1s-13.1,5.9-13.1,13.1,5.9,13.1,13.1,13.1,13.1-5.9,13.1-13.1Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.8,184.4l-9,13.8h-.6l-9.1-13.8v21h-1.8v-23.6h2.2l9,13.8,8.9-13.8h2.2v23.6h-1.8v-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.8,181.8v14.7c0,12.3-18.1,12.4-18.1,0v-14.7h1.8v14.7c0,10.2,14.5,10.1,14.5,0v-14.7h1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M324.1,186.3c-1.7-2.8-4.5-3.2-7.2-3.2-2.8,0-7.2,1-7.2,4.8s3.2,3.7,7.2,4.5c4.6.9,9.3,1.7,9.3,6.8,0,5.3-5.4,6.6-9.3,6.6s-7.9-1.5-9.7-5.1l1.6-.8c1.5,2.9,5.2,4.3,8.1,4.3s7.5-.8,7.5-5c0-3.5-3.9-4.3-7.8-5.1-4.3-.8-8.7-1.7-8.7-6.1-.1-5,5.1-6.5,9-6.5s6.3.5,8.6,4l-1.5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332,181.8v21.9h13.3v1.7h-15.1v-23.6h1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.7,205.4v-23.6h1.8v23.6h-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.3,184.4l-9,13.8h-.6l-9.1-13.8v21h-1.8v-23.6h2.2l9,13.8,8.9-13.8h2.2v23.6h-1.8v-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M407.9,186.3c-1.7-2.8-4.5-3.2-7.2-3.2-2.8,0-7.2,1-7.2,4.8s3.2,3.7,7.2,4.5c4.6.9,9.3,1.7,9.3,6.8,0,5.3-5.4,6.6-9.3,6.6s-7.9-1.5-9.7-5.1l1.6-.8c1.5,2.9,5.2,4.3,8.1,4.3s7.5-.8,7.5-5c0-3.5-3.9-4.3-7.8-5.1-4.3-.8-8.7-1.7-8.7-6.1-.1-5,5.1-6.5,9-6.5s6.3.5,8.6,4l-1.5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.7,183.4h-8.5v-1.6h18.9v1.6h-8.5v22h-1.8v-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.3,181.8v14.7c0,12.3-18.1,12.4-18.1,0v-14.7h1.8v14.7c0,10.2,14.5,10.1,14.5,0v-14.7h1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478,193.3c.1,6-3.7,12.1-12,12.1h-8v-23.6h8c8,0,11.8,5.7,12,11.5ZM459.9,183.5v20.1h6.2c7,0,10.3-5.3,10.2-10.3-.1-4.9-3.3-9.8-10.2-9.8h-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.9,192.7h13.8v1.7h-13.8v9.3h14.9v1.8h-16.7v-23.6h16.3v1.7h-14.5v9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.4,181.8l15.9,19.5v-19.5h1.8v23.6h-.7l-15.9-19.5v19.5h-1.8v-23.6h.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M534,183.4h-8.5v-1.6h18.9v1.6h-8.5v22h-1.8v-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M575.9,205.4l-2.6-5.8h-14.1l-2.6,5.8h-2l10.6-23.6h2l10.6,23.6h-2ZM572.6,197.9l-6.3-14.4-6.3,14.4h12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M595.8,186.3c-1.7-2.8-4.5-3.2-7.2-3.2-2.8,0-7.2,1-7.2,4.8s3.2,3.7,7.2,4.5c4.6.9,9.3,1.7,9.3,6.8,0,5.3-5.4,6.6-9.3,6.6s-7.9-1.5-9.7-5.1l1.6-.8c1.5,2.9,5.2,4.3,8.1,4.3s7.5-.8,7.5-5c0-3.5-3.9-4.3-7.8-5.1-4.3-.8-8.7-1.7-8.7-6.1-.1-5,5.1-6.5,9-6.5s6.3.5,8.6,4l-1.5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M617.2,186.3c-1.7-2.8-4.5-3.2-7.2-3.2-2.8,0-7.2,1-7.2,4.8s3.2,3.7,7.2,4.5c4.6.9,9.3,1.7,9.3,6.8,0,5.3-5.4,6.6-9.3,6.6s-7.9-1.5-9.7-5.1l1.6-.8c1.5,2.9,5.2,4.3,8.1,4.3s7.5-.8,7.5-5c0-3.5-3.9-4.3-7.8-5.1-4.3-.8-8.7-1.7-8.7-6.1-.1-5,5.1-6.5,9-6.5s6.3.5,8.6,4l-1.5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M646,193.6c0,6.2-4,12.2-11.9,12.2s-11.9-6-11.9-12.2,3.9-12.1,11.9-12.1,11.9,5.8,11.9,12.2ZM624,193.6c0,5.3,3.4,10.5,10.1,10.5s10.2-5.2,10.2-10.5-3.4-10.5-10.2-10.5-10.2,4.9-10.1,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M669.8,202.1c-2.4,2.4-5.5,3.5-8.6,3.5-8,0-12.1-5.6-12.1-11.9,0-6.3,4-12.2,12.1-12.2s6.2,1.2,8.6,3.5l-1.2,1.1c-2-2-4.7-3-7.4-3-6.9,0-10.4,4.9-10.4,10.5,0,5.5,3.6,10.3,10.4,10.3s5.4-1,7.4-3l1.2,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M674.2,205.4v-23.6h1.8v23.6h-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M699.9,205.4l-2.6-5.8h-14.1l-2.6,5.8h-2l10.6-23.6h2l10.6,23.6h-2ZM696.6,197.9l-6.3-14.4-6.3,14.4h12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M707.8,183.4h-8.5v-1.6h18.9v1.6h-8.5v22h-1.8v-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M721.6,205.4v-23.6h1.8v23.6h-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M752.1,193.6c0,6.2-4,12.2-11.9,12.2s-11.9-6-11.9-12.2,3.9-12.1,11.9-12.1,11.9,5.8,11.9,12.2ZM730.1,193.6c0,5.3,3.4,10.5,10.1,10.5s10.2-5.2,10.2-10.5-3.4-10.5-10.2-10.5-10.2,4.9-10.1,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M757.2,181.8l15.9,19.5v-19.5h1.8v23.6h-.7l-15.9-19.5v19.5h-1.8v-23.6h.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsaPsgLogoWhite);
export default __webpack_public_path__ + "static/media/msa-psg-logo_white.c57d1cc28353d09b4bac8df25a959599.svg";
export { ForwardRef as ReactComponent };